module.exports = __webpack_public_path__ + "7cea3ea1546416bee85d0ba7b3d519cd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/magic-wand-right.png
// module id = 3019
// module chunks = 0